import * as React from 'react';
import { delay } from '../../components/utils';
import {
  TestkitOutputUni,
  uniTestkitFactoryCreator,
} from '@wix/wix-ui-test-utils/vanilla';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/dist/types/base-driver';
import { generateKey } from '../../common/random';
import { st, classes } from './VisualAsync.st.css';

interface VisualAsyncProps<T extends BaseUniDriver> {
  children: React.ReactElement<any>;
  driverFactory: TestkitOutputUni<T>;
  onDone: () => void;
  action: (driver: T) => Promise<void>;
  dataHook?: string;
  checkered?: boolean;
}

/* TODO: JB: there are multiple similar components that do similar thing that could be refactored */
export const VisualAsync = <T extends BaseUniDriver>({
  children,
  driverFactory,
  onDone,
  action,
  checkered,
}: VisualAsyncProps<T>) => {
  const dataHook = React.useMemo(() => generateKey(), []);
  const [isActionDone, setIsActionDone] = React.useState(false);

  React.useEffect(() => {
    const runAction = async () => {
      if (onDone) {
        const factory = uniTestkitFactoryCreator(driverFactory);
        const driver = factory({
          wrapper: document.body,
          dataHook,
        });

        await action(driver);
        setIsActionDone(true);
      }
    };

    runAction();
  }, [onDone, driverFactory, action, dataHook]);

  React.useEffect(() => {
    const notifyDone = async () => {
      if (onDone && isActionDone) {
        await delay(250);
        onDone();
      }
    };

    notifyDone();
  }, [onDone, isActionDone]);

  return (
    <EditorShell checkered={checkered}>
      {React.cloneElement(React.Children.only(children), {
        'data-hook': dataHook,
      })}
    </EditorShell>
  );
};

/** @deprecated will be removed after focus ring is checked on all components */

export const EditorShell: React.FC<{ checkered?: boolean }> = (props) => (
  <div className="outline-experiment-off">
    <link type="text/css" rel="stylesheet" href="global-styles.css" />
    <div
      id="SITE_CONTAINER"
      className={st('focus-ring-active', props.checkered ? classes.root : '')}
    >
      {props.children}
    </div>
  </div>
);
